<template>
  <v-row>
    <v-col cols="12">

      <div class="body-1">
        <strong>{{ title }}</strong>
        <span class="font-weight-bold caption info--text"
              v-if="isItemRequired()"
        >(Obligatorio)</span>
      </div>

      <!-- START CHECKBOX -->
      <div class="body-1"
           v-if="isItemMultiple()"
           justify="space-around"
      >
        <v-checkbox multiple
                    hide-details
                    class="ma-1"
                    v-for="(option, indexOption) in options"
                    :key="indexOption"
                    :value="option"
                    :disabled="disabled"
                    v-model="optionsChecked[productId]"
                    @change="updateTotalPrice()"
        >
          <template v-slot:label>
            {{ option.label }} <strong class="ml-2 caption font-weight-bold"> +{{ option.price | currency }}</strong>
          </template>
        </v-checkbox>
      </div>
      <!-- END CHECKBOX -->

      <!-- START RADIO -->
      <div class="body-1"
           v-else
      >
        <v-radio-group row
                       hide-details
                       :disabled="disabled"
                       v-model="optionSelected[productId]"
                       @change="updateTotalPrice()"
        >
          <v-radio class="ma-1"
                   v-for="(option, indexOption) in options"
                   :key="indexOption"
                   :value="option"
          >
            <template v-slot:label>
              {{ option.label }}
              <strong class="ml-2 caption font-weight-bold">
                +{{ option.price | currency }}
              </strong>
            </template>
          </v-radio>
        </v-radio-group>
      </div>
      <!-- END RADIO -->

    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ProductAdditives",
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      default: new Array(0)
    },
    productId: {
      type: String,
      required: true,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      optionsChecked: [],
      optionSelected: {},
      totalPrice: 0
    }
  },
  methods: {
    isItemRequired() {
      return this.required
    },

    isItemMultiple() {
      return this.multiple
    },

    updateTotalPrice() {
      this.totalPrice = 0

      if (this.isItemMultiple()){
        this.totalPrice = this.getTotalPriceOfOptionsChecked()
      } else {
        this.totalPrice = this.getTotalPriceOfOptionSelected()
      }

      this.emitTotalPriceAdditives()
    },

    emitTotalPriceAdditives() {
      this.$emit('update:totalPriceAdditives', this.totalPrice)
    },

    getTotalPriceOfOptionsChecked() {
      let total = 0
      let options = this.optionsChecked[this.productId]

      if (options){
        options.forEach(value => total += value.price)
      }

      return total
    },

    getTotalPriceOfOptionSelected() {
      let total = 0
      let option = this.optionSelected[this.productId]

      if (option){
        total = option.price
      }

      return total
    },
  }
}
</script>